import { render, staticRenderFns } from "./AtmSection.vue?vue&type=template&id=319169d9&"
import script from "./AtmSection.vue?vue&type=script&lang=js&"
export * from "./AtmSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports